import DesktopZoomableImage from './ZoomableImage';

export default DesktopZoomableImage;
